import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { BrandsServiceProvider } from '@services/brands/brands.service';
import { ValidationProvider } from '@services/helpers/validation.service';
import { AccountServiceProvider } from '@services/user/account.service';
import { BrandDetailsInfo } from '@models/brands.model';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'brand-create-modal',
	template: require('./brand-create-modal.html'),
	styles: [require('./brand-create-modal.scss')]
})
export class BrandCreateModalComponent implements OnInit, OnDestroy {
	brandForm = this.fb.group({
		name: ['', [Validators.required, ValidationProvider.noWhitespaceValidator]],
		email: [
			'',
			[
				Validators.required,
				ValidationProvider.emailValidator,
				ValidationProvider.noWhitespaceValidator
			]
		]
	});
	importData = true;
	btnDisable: boolean;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private activeModal: NgbActiveModal,
		private fb: FormBuilder,
		private brandsDataService: BrandsDataServiceProvider,
		private brandsService: BrandsServiceProvider,
		private accountService: AccountServiceProvider,
		private messageService: MessageService
	) {}

	ngOnInit(): void {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	closeModal(): void {
		this.activeModal.dismiss();
	}

	saveData(): void {
		if (this.brandForm.valid) {
			this.createBrand();
		} else {
			this.validateForErrors();
		}
	}

	createBrand(): void {
		this.btnDisable = true;
		if (this.importData) {
			this.activeModal.close({ action: 'IMPORT', props: this.brandForm.value });
		} else {
			this.accountService
				.saveBrand(this.brandForm.value)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize(() => (this.btnDisable = false))
				)
				.subscribe((res: BrandDetailsInfo): void => {
					this.brandsDataService
						.updateBrands()
						.pipe(
							takeUntil(this.unsubscribe),
							finalize((): boolean => (this.btnDisable = false))
						)
						.subscribe(() => {
							this.activeModal.close({ action: 'REDIRECT', props: res });
						});
				});
		}
	}

	private validateForErrors(): void {
		this.brandsService.validateBrandFields(this.brandForm.controls);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.ts